import { BaseModal } from './BaseModal'
import { Button } from 'app-v2/design-systems/components/inputs/button'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { colors } from 'app-v2/design-systems/theme'
import { ModalCover } from './ModalCover'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import type { Gain } from 'shared/store/tu-preferes-king/types'
import { resetState } from 'shared/store/tu-preferes-king'
import type { WinningType } from '../../../types'
import styled from 'styled-components'

const { white, crunchyGreen } = colors

type ModalProps = {
    visible: boolean,
    onClose: () => void,
    selectedWinning: Gain,
    email: string,
    type: WinningType
}
export function DoneModal(props: ModalProps) {
    const intl = useIntl()
    const dispatch = useDispatch()
    return (
        <BaseModal
            visible={props.visible}
            onClose={props.onClose}
            title={intl.formatMessage({
                id: 'tupreferesking.win.modal.done.title'
            })}
            subtitle={
                <FormattedMessage
                    id={
                        props.selectedWinning.immediateGain
                            ? 'tupreferesking.win.modal.done.text.immediate'
                            : 'tupreferesking.win.modal.done.text.later'
                    }
                    values={{
                        email: _ => (
                            <StyledEmailAddress>
                                {props.email}
                            </StyledEmailAddress>
                        )
                    }}
                />
            }
            buttons={
                <Button
                    fullLength
                    buttonColor={crunchyGreen}
                    labelColor={white}
                    onClick={() => {
                        dispatch(
                            push({
                                pathname: intl.formatMessage({
                                    id: 'routes.tupreferesking'
                                })
                            })
                        )
                        dispatch(resetState())
                    }}>
                    {intl.formatMessage({
                        id: 'tupreferesking.win.modal.done.cta'
                    })}
                </Button>
            }
            cover={
                <ModalCover
                    selected={props.type}
                    winning={props.selectedWinning}
                />
            }
        />
    )
}

const StyledEmailAddress = styled.span`
    color: ${colors.flamingOrange};
`
